export const colorConfig = {
  blue: {
    "game-item": {
      mask: "rgba(137, 192, 245, 0.4)",
    },
    brand: {
      300: "#89C0F5",
      500: "#67A9E0",
      600: "#4F91CC",
      700: "#3B7AB8",
      900: "#2A5E95",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa",
      gold: "#89C0F5",
    },
    "right-promotion-box": {
      from: "#e1f2ff",
      to: "#b3dfff",
      hover_from: "#8dc9ff",
      hover_to: "#67A9E0",
      border: "#4F91CC",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
  },
  yellow: {
    "game-item": {
      mask: "rgba(254, 192, 14, 0.4)",
    },
    brand: {
      300: "#FFAA5E",
      500: "#fec00e",
      600: "#e9b00e",
      700: "#e9b00e",
      900: "#bd8e08",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa", //light-text
      gold: "#ffc700",
    },
    "right-promotion-box": {
      from: "#ffe5bf",
      to: "#ffc881",
      hover_from: "#ffbc44",
      hover_to: "#ff892e",
      border: "#866b25",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
  },
  green: {
    "game-item": {
      mask: "rgba(183, 255, 100, 0.4)",
    },
    brand: {
      300: "#B7FF64",
      500: "#A2E04A",
      600: "#8FCC39",
      700: "#7DBA29",
      900: "#5E8A1C",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa", //light-text
      gold: "#B7FF64", // 用綠色替代
    },
    "right-promotion-box": {
      from: "#e3ffbf",
      to: "#bfffa3",
      hover_from: "#a3e07f",
      hover_to: "#7DBA29",
      border: "#5E8A1C",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
  },
  purple: {
    "game-item": {
      mask: "rgba(178, 102, 255, 0.4)",
    },
    brand: {
      300: "#E3C3FF",
      500: "#C299FF",
      600: "#A366FF",
      700: "#8C4DF0",
      900: "#7327D4",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa",
      gold: "#C299FF",
    },
    "right-promotion-box": {
      from: "#f3e1ff",
      to: "#d9b7ff",
      hover_from: "#b184f0",
      hover_to: "#A366FF",
      border: "#8C4DF0",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
  },
  red: {
    "game-item": {
      mask: "rgba(255, 102, 102, 0.4)",
    },
    brand: {
      300: "#FFA3A3",
      500: "#FF6666",
      600: "#F04D4D",
      700: "#D43232",
      900: "#A32222",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa",
      gold: "#FF6666",
    },
    "right-promotion-box": {
      from: "#ffe1e1",
      to: "#ffb3b3",
      hover_from: "#ff8c8c",
      hover_to: "#FF6666",
      border: "#F04D4D",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
  },
  "light-green": {
    "game-item": {
      mask: "rgba(83, 222, 161, 0.4)",
    },
    brand: {
      300: "#A4F3CF",
      500: "#53DEA1",
      600: "#45C38A",
      700: "#42BA84",
      900: "#319764",
    },
    "second-brand": {
      500: "#b7ff64",
      700: "#09d7eb",
    },
    special: {
      1: "#8fa8aa",
      gold: "#53DEA1",
    },
    "right-promotion-box": {
      from: "#D6F7E9",
      to: "#A4F3CF",
      hover_from: "#78E8B2",
      hover_to: "#53DEA1",
      border: "#42BA84",
      background: {
        platformBg: "#e3e3e3",
        transactionCard: "#fff",
      },
    },
    light: {
      100: "#f1f2f4",
      200: "#ffffff",
      300: "#DDE0E3", //deep-gray
      350: "rgb(170,170,170)",
      400: "#535353",
      500: "#15191C", //input-gray
      600: "#5f5f5f",
    },
    dark: {
      100: "#191C33",
      200: "#110F1C",
      300: "#0F0D1A",
      400: "#110F1E",
      500: "#0B0916",
      600: "#090714",
    },
    "header-gradient": {
      from: "#7ef5d3",
      to: "#52dcab",
    },
  },
};
